import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getPermissoes({ commit }) {
      try {
        const response = await api.get('/permissoes')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
